class Modal extends Controller {
	constructor(...args){
		super(...args);
		this.stateActiveClass = (this.options.statesClasses && this.options.statesClasses.active) || 'active';
		this.options.openSelector = this.options.openSelector || '[data-modal]';
		this.closeElement = this.scope.querySelector(this.options.closeSelector);
		this.initElements();
		this.initEvents();
	}
	initElements(){
		this.$content = this.scope.querySelector(this.options.contentSelector);
	}
	initEvents(){
		this.scope.addEventListener('click', (e)=>{
			if(e.target===this.scope){
				this.active = false;
			}
		});
		window.addEventListener('keydown', (e)=>{
			if(this.active && e.keyCode === 27){
				this.active = false;
			}
		});
		this.closeElement.addEventListener('click',(e)=>{
			this.active = false;
			e.preventDefault();
		});
		window.addEventListener('load', (e)=>{
			if(this.active){
				this.scope.dispatchEvent(new CustomEvent('modal.active', {bubbles: true, detail: this}));
			}
		});
		window.addEventListener('hashchange', (e)=>{
			if(e.newURL.split('#')[1] === this.scope.id || e.oldURL.split('#')[1] === this.scope.id){
				this.scope.dispatchEvent(new CustomEvent('modal.active', {bubbles: true, detail: this}));
			}
		});
	}
	get active(){
		return window.location.hash && this.scope.id===window.location.hash.substr(1);
	}
	set active(v){
		window.location.hash = v?this.scope.id:0;
	}
	set content(v){
		this.$content.innerHTML = v;
		this.$content.querySelectorAll('script').forEach(Zv.insertScript);
	}
}
class Modals extends Controller {
	constructor(...args){
		super(...args);
		this.items = []; //TODO: Учесть возможность динамического добавления окна!!
		this
			.initElements()
			.initEvents();
		this.hasActive;
	}
	initElements(){
		// let itemsNl = this.scope.querySelectorAll(this.options.itemSelector);
		this.scope.querySelectorAll(this.options.itemSelector).forEach((node)=>this.pushItem(node));
		return this;
	}
	initEvents() {
		window.addEventListener('hashchange', (e)=> {
			document.body.classList.toggle(this.options.bodyModalStateClass, this.hasActive);
		});
		window.addEventListener('load', (e)=>{
			document.body.classList.toggle(this.options.bodyModalStateClass, this.hasActive);
		});
		return this;
	}
	get hasActive(){
		return this.items.filter((item)=>item.active).length;
	}
	pushItem(node){
		let itemOptions = {
			// itemSelector: this.options.itemSelector,
			contentSelector: this.options.itemContentSelector,
			stateActiveClass: this.options.itemActiveClass,
			openSelector: this.options.itemOpenSelector,
			closeSelector: this.options.itemCloseSelector
		};
		this.items.push(new Modal(node, itemOptions, this));
	}
	getById (id){
		return items.get(id);
	}
}